export const GUESTS_READ = "guests.read";
export const GUESTS_MANAGE = "guests.manage";
export const GUESTS_CHECKIN = "guests.checkin";
export const GUESTS_OVERRIDE = "guests.override";
export const GUESTS_POLICY = "guests.policy";
